import { render, staticRenderFns } from "./filterRegion.vue?vue&type=template&id=20c8af41&scoped=true"
import script from "./filterRegion.vue?vue&type=script&lang=js"
export * from "./filterRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8af41",
  null
  
)

export default component.exports